import { IS_MOSAIC_CHART } from "constants/chart.constants";
import { EvaChart } from "constants/charts.enums";

export const disableAxisLocks = (chartType) => {
  if (chartType === EvaChart.Pie || IS_MOSAIC_CHART(chartType)) return false;

  return true;
};
